import { observer } from "mobx-react-lite";
import { ViewGridIcon, ViewListIcon } from "@heroicons/react/outline";

import { useGridContext, ViewMode } from "../hooks/useEvaluateGridContext";

import { BasicTooltip } from "@/components/ui/Tooltip";

export const ViewHeightSection = observer(() => {
  const { tableStore } = useGridContext();

  const handleViewModeChange = (mode: ViewMode) => {
    tableStore?.setViewMode(mode);
  };

  const isCompact = tableStore?.viewMode === ViewMode.COMPACT;

  return (
    <div className="mb-3">
      <div className="mb-2 flex items-center justify-between">
        <h4 className="text-xs font-medium uppercase tracking-wide text-gray-600">Row Height</h4>
      </div>

      <div className="flex items-center rounded-lg bg-gray-100 p-1">
        <BasicTooltip content="Compact view">
          <button
            className={`flex flex-1 items-center justify-center gap-1.5 rounded-md px-2 py-1.5 text-xs font-medium transition-all ${
              isCompact ? "bg-white text-gray-900 shadow-sm" : "text-gray-600 hover:text-gray-900"
            }`}
            onClick={() => handleViewModeChange(ViewMode.COMPACT)}
          >
            <ViewListIcon className="h-3.5 w-3.5" />
          </button>
        </BasicTooltip>
        <BasicTooltip content="Expanded view">
          <button
            className={`flex flex-1 items-center justify-center gap-1.5 rounded-md px-2 py-1.5 text-xs font-medium transition-all ${
              !isCompact ? "bg-white text-gray-900 shadow-sm" : "text-gray-600 hover:text-gray-900"
            }`}
            onClick={() => handleViewModeChange(ViewMode.EXPANDED)}
          >
            <ViewGridIcon className="h-3.5 w-3.5" />
          </button>
        </BasicTooltip>
      </div>
    </div>
  );
});
